import { configureStore } from '@reduxjs/toolkit';
import { appApi } from './api';
import appReducer from './slice';
import chatReducer from './chatSlice';

export const store = configureStore({
    reducer: {
        app: appReducer,
        chat: chatReducer,
        [appApi.reducerPath]: appApi.reducer,
    },
    middleware: (getDefaultMiddleware) => getDefaultMiddleware().concat(appApi.middleware),
});

export type RootState = ReturnType<typeof store.getState>;
export type AppDispatch = typeof store.dispatch;
